import { map } from 'rxjs/operators';

import { DynamicSearchPayload } from '@ispm-shared/modules/common/dynamic-search';
import { HttpInterceptorService } from '@ispm/core/services/http-interceptor.service';
import { NavigationConfigService } from '@ispm/navigation/services/navigationConfig.service';
import { ResourceTypes } from '../interfaces';

export abstract class ResourceHelperService {
  set association(value) {
    this._association = value;
  }

  set type(value) {
    this._type = value;
  }

  set chunk(value) {
    this._chunkAmount = value || 400;
  }

  set dynamicSearchQuery(value) {
    this._dynamicSearch = value || { };
  }

  set resource(value) {
    this._resource = value;
  }

  public static readonly baseUrl = '/workflow';

  protected _association: Array<any>;
  protected _chunkAmount = 400;
  protected _type: string = ResourceTypes.Generic;
  protected _dynamicSearch: DynamicSearchPayload;
  protected _resource: string = 'DiagnosticOrder';

  protected constructor(
    protected _http: HttpInterceptorService,
    protected _navigationConfigService: NavigationConfigService
  ) {
  }

  getConfigResourceTemplate(type: string) {
    const params = {
      application: this._navigationConfigService.getCurrentApplicationId()
    };

    return this._http.get(ResourceHelperService.baseUrl + '/getWorklistTemplate/' + type, params)
      .pipe(
        map(data => data.json()),
      );
  }

  abstract getResourceIds(
    query: any,
    page: number,
    sortField: string,
    sortOrder: string | number,
    hasSearchMode,
    isClubbed?: boolean,
    configTemplateType?: string,
    resourceType?: string,
    patientIds?: string,
    sortByType?,
    sortPath?,
    associationItems?,
    adaptableFilters?,
  );

  abstract getSelectedTreatment(revision: string);

  abstract getQuery(
    page: number,
    sortField: string,
    sortOrder: string | number,
    sortByType: string,
    sortPath: boolean,
    associationItems?: Array<any>,
    adaptableFilters?: any,
    resourceIds?: string
  );

  abstract getResource(
    field_list,
    resources_ids,
    associationItems?: Array<any>,
    adaptableFilters?: any,
    additionalParams?: any
  );

  abstract getResourceIdsPatientTests(
    patientId: string,
    orgId: string
  );

  abstract getTreatments(
    patientId: string,
    revision: string
  );

  abstract getTotalEntities();
}
